import React from 'react'
import styles from './GalleryPagination.module.css'
import { BasicStyledComponent } from 'shared-definitions/types'
import clsx from 'clsx'
import ArrowLeft from 'shared-svg/ArrowLeft.svg'
import RWButton from '../buttons/RWButton'

export interface GalleryPaginationProps extends BasicStyledComponent {
  currentPage: number // 0 based index
  totalPages: number
  onPageChange: (page: number) => void
}

export const GalleryPagination: React.FC<GalleryPaginationProps> = ({
  className,
  currentPage,
  totalPages,
  onPageChange,
}) => (
  <nav className={clsx(styles.container, className)}>
    <div className={styles.dots}>
      {Array.from({ length: Math.ceil(totalPages) }, (_, index) => (
        <button
          type="button"
          onClick={() => onPageChange(index)}
          className={clsx(styles.dot, { [styles.dotActive]: index === currentPage })}
          key={index}
        />
      ))}
    </div>
    <div className={styles.buttons}>
      <RWButton
        variant="outline"
        size="small"
        type="button"
        className={styles.button}
        onClick={() => onPageChange(currentPage - 1)}
        disabled={currentPage <= 0}
        aria-label="Previous"
      >
        <ArrowLeft className={styles.arrow} />
      </RWButton>
      <RWButton
        variant="outline"
        size="medium"
        aria-label="Next"
        type="button"
        className={styles.button}
        onClick={() => onPageChange(currentPage + 1)}
        disabled={currentPage >= totalPages - 1}
      >
        <ArrowLeft className={clsx(styles.arrow, styles.rotated)} />
      </RWButton>
    </div>
  </nav>
)
